import MiscHeading from '@pc/components/Works/Panel/shared/Heading/MiscHeading'
import type { SearchParamsAttributes } from '@pc/components/Works/Panel/types'
import FeatureBox from './FeatureBox'
import type { ChangeEvent } from 'react'

interface PropsType {
  freeWord: SearchParamsAttributes['free_word']
  changeState: (arg: any) => void
}

const FreewordBox = (props: PropsType) => {
  const { freeWord, changeState } = props

  const changeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const freeWord = e.target.value
    changeState({ freeWord })
  }

  return (
    <FeatureBox>
      <MiscHeading>フリーワード検索</MiscHeading>
      <input
        className="mt-2.5 ext-textfield h-10 w-62 px-2 text-[13px] placeholder:text-gray-500"
        type="text"
        placeholder="(例)渋谷 カフェ"
        value={freeWord ?? ''}
        onChange={changeInput}
      />
    </FeatureBox>
  )
}

export default FreewordBox
